import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import styled from 'styled-components'

const ManualCardSmallSkeletonContainer = styled.div`
	overflow: hidden;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 16px 8px;
	width: 100%;
	border-bottom: 1px solid #eeeeee;

	& > div {
		width: 70%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	@media (max-width: 340px) {
		padding: 16px 10px;
	}

	@media (min-width: 768px) {
		padding: 8px 60px 16px 36px;
		border-bottom: none;
		margin: 0 0 12px;
	}
`

const MetaRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;
	margin-bottom: 10px;
`

const ManualCardSmallSkeleton = () => {
	return (
		<ManualCardSmallSkeletonContainer>
			<div>
				<MetaRow>
					<Skeleton width={80} height={14} />
					<Skeleton width={90} height={14} />
				</MetaRow>
				<Skeleton width='90%' height={20} style={{ maxWidth: '210px' }} />
			</div>

			<Skeleton width={80} height={85} style={{ borderRadius: '3px' }} />
		</ManualCardSmallSkeletonContainer>
	)
}

export default ManualCardSmallSkeleton
